module.exports = __webpack_public_path__ + "media/images/games/k2reveal/bridge-8db1f936bb63ff1e7a4c2dd735025533.png";